import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone:false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], term: string): any {
    if (!items || !term)
      return items;
    return items.filter(item => {
      let result = item.Name.toLowerCase().includes(term.toLowerCase());
      return result;
    });
  }

}
@Pipe({
  name: 'filterByProp',
  pure: false,
  standalone:false
})
export class FilterPropertyPipe implements PipeTransform {

  transform(items: any[], filter: { property: string, term: string }): any {
    if (!items || !filter)
      return items;
    if (!filter.term || !filter.property || filter.term.length < 2)
      return items;
    let properties = filter.property.split(".");

    return items.filter(item => {
      let data;
      properties.forEach((x, index) => {
        if (index === 0)
          data = item[x];
        else
          data = data[x];
      })
      let result = data.toLowerCase().includes(filter.term.toLowerCase());
      return result;
    });
  }

}

@Pipe({
  name: 'filterreceipts'
})
export class FilterReceiptsPipe implements PipeTransform {

  transform(items: any[], selectedChip: string): any {
    if (!items || selectedChip === "all")
      return items;

    let regexp;
    if (selectedChip === "app") {
      regexp = /^.*app$/
    }
    if (selectedChip === "pos") {
      regexp = /^((?!app)[\s\S])*$/;
    }
    return items.filter(item => {
      if ((selectedChip === "market")) {
        if (item.digitalOrder)
          return (item.digitalOrder.data.orderType === "minimarket")
        else return false;
      } else {
        let any = []
        any = item.payments.filter(payment => {
          if (payment.description.toLowerCase().match(regexp)) {
            return true;
          }
          return false;

        })
        return any.length > 0;
      }

    });
  }

}

